// @flow

export type ContextLogEventType = $Values<PCONST.thrift.EventType>;

export type ContextLog = {
  type: 'CONTEXT_LOG_EVENT',
  payload: { name: ContextLogEventType, properties: Object },
};

const contextLog = (name: ContextLogEventType, properties?: Object = {}): ContextLog => ({
  type: 'CONTEXT_LOG_EVENT',
  payload: {
    name,
    properties,
  },
});

export type ContextLogFunc = typeof contextLog;

// TODO (btraut): Figure out the cryptic flow error when we remove the any. It
// appears to be related to the way withContextLog (which uses connect
// internally) interacts with defaultProps:
// https://stackoverflow.com/questions/50729455/flow-errors-when-a-component-prop-with-a-default-value-is-wired-up-by-react-redu#_=_
export default (contextLog: any);
